import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import jcApi, { favoriteSpotsPath } from '../../api_client';
import { setToken } from '../../loadUser';
import { GET_USER_TOKEN, GET_FAVORITE_SPOTS, CREATE_FAVORITE_SPOT, DELETE_FAVORITE_SPOT, SAVE_FAVORITE_SPOT_ID, SET_API_PARAMS, AUTH_WINDOW } from './types';
export var setApiParams = function setApiParams(params) {
  return {
    type: SET_API_PARAMS,
    payload: params
  };
};
export var setAuthWindow = function setAuthWindow(authWindow) {
  return {
    type: AUTH_WINDOW,
    payload: authWindow
  };
};
export var getFavoriteSpots = function getFavoriteSpots() {
  return (
    /*#__PURE__*/
    function () {
      var _ref = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(dispatch, getState) {
        var _getState, userToken, _getState$api, key, url, _ref2, data;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _getState = getState(), userToken = _getState.userToken, _getState$api = _getState.api, key = _getState$api.key, url = _getState$api.url;
                _context.next = 3;
                return jcApi({
                  userToken: userToken,
                  key: key,
                  url: url
                }).get(favoriteSpotsPath());

              case 3:
                _ref2 = _context.sent;
                data = _ref2.data;
                dispatch({
                  type: GET_FAVORITE_SPOTS,
                  payload: data.data.map(function (spotData) {
                    return spotData.attributes;
                  })
                });

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }()
  );
};

var createFavoriteSpot = function createFavoriteSpot(_ref3) {
  var id = _ref3.id,
      externalId = _ref3.externalId;
  return (
    /*#__PURE__*/
    function () {
      var _ref4 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(dispatch, getState) {
        var _getState2, userToken, _getState2$api, key, url, _ref5, data;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _getState2 = getState(), userToken = _getState2.userToken, _getState2$api = _getState2.api, key = _getState2$api.key, url = _getState2$api.url;
                _context2.next = 3;
                return jcApi({
                  userToken: userToken,
                  key: key,
                  url: url
                }).post(favoriteSpotsPath(), {
                  id: id,
                  externalId: externalId
                });

              case 3:
                _ref5 = _context2.sent;
                data = _ref5.data;
                dispatch({
                  type: CREATE_FAVORITE_SPOT,
                  payload: data.data.attributes
                });

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x3, _x4) {
        return _ref4.apply(this, arguments);
      };
    }()
  );
};

export var saveUserToken = function saveUserToken(token) {
  return function (dispatch, getState) {
    var _getState3 = getState(),
        authWindow = _getState3.authWindow,
        favoriteSpotIds = _getState3.favoriteSpotIds;

    if (authWindow) {
      authWindow.close();
      dispatch(setAuthWindow(null));
    }

    setToken(token);
    dispatch({
      type: GET_USER_TOKEN,
      payload: token
    });
    dispatch(getFavoriteSpots());
    favoriteSpotIds.forEach(function (id) {
      dispatch(createFavoriteSpot(id));
    });
  };
};

var saveFavoriteSpotId = function saveFavoriteSpotId(id) {
  return {
    type: SAVE_FAVORITE_SPOT_ID,
    payload: id
  };
};

export var deleteFavoriteSpot = function deleteFavoriteSpot(id) {
  return (
    /*#__PURE__*/
    function () {
      var _ref6 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(dispatch, getState) {
        var _getState4, userToken, _getState4$api, key, url;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _getState4 = getState(), userToken = _getState4.userToken, _getState4$api = _getState4.api, key = _getState4$api.key, url = _getState4$api.url;
                _context3.next = 3;
                return jcApi({
                  userToken: userToken,
                  key: key,
                  url: url
                }).delete(favoriteSpotsPath(id));

              case 3:
                dispatch({
                  type: DELETE_FAVORITE_SPOT,
                  payload: id
                });

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x5, _x6) {
        return _ref6.apply(this, arguments);
      };
    }()
  );
};
export var addFavoriteSpot = function addFavoriteSpot(params) {
  return function (dispatch, getState) {
    var _getState5 = getState(),
        userToken = _getState5.userToken,
        authWindow = _getState5.authWindow,
        _getState5$api = _getState5.api,
        url = _getState5$api.url,
        key = _getState5$api.key;

    if (userToken) {
      dispatch(createFavoriteSpot(params));
    } else {
      dispatch(saveFavoriteSpotId(params));

      if (!authWindow) {
        dispatch(setAuthWindow(window.open("".concat(url, "/user?api_key=").concat(key))));
      }
    }
  };
};